module.exports = __webpack_public_path__ + "img/line.648c95a1.svg";